import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ExportJob {
    jobUuid: string;
    jobStatus: 'PENDING' | 'PROCESSING' | 'COMPLETED' | 'FAILED';
    jobType: string;
    requestedBy: string;
    message: string;
    createdAt: string;
}

export interface ExportJobsResponse {
    traceId: string;
    timestamp: string;
    data: {
        jobs: ExportJob[];
        total: number;
    };
}

@Injectable({
    providedIn: 'root'
})
export class AnalyticsService {

    constructor(private http: HttpClient) { }

    /**
     * Obtiene la lista de clientes para filtros
     */
    getClients(): Observable<any> {
        let params = new HttpParams();
        return this.http.get(`${environment.api_url}/clients/search`, { params });
    }

    /**
     * Obtiene los catálogos en cascada
     */
    getCatalogs(clientId?: string): Observable<any> {
        let params = new HttpParams();
        if (clientId) params = params.set('clientId', clientId);
        return this.http.get(`${environment.api_url}/catalogs/by-client`, { params });
    }

    getSuccessMetrics(filters: any): Observable<any> {
        const params = this.buildParams(filters);
        return this.http.get(`${environment.api_url}/metrics/success-request`, { params });
    }

    getErrorMetrics(filters: any): Observable<any> {
        const params = this.buildParams(filters);
        return this.http.get(`${environment.api_url}/metrics/error-request`, { params });
    }

    getSuccessReport(filters: any): Observable<Blob> {
        const params = this.buildParams(filters);
        return this.http.get(`${environment.api_url}/reports/success-request`, {
            params, responseType: 'blob'
        });
    }

    getErrorReport(filters: any): Observable<Blob> {
        const params = this.buildParams(filters);
        return this.http.get(`${environment.api_url}/reports/error-request`, {
            params, responseType: 'blob'
        });
    }

    requestExportJob(filters: any): Observable<ExportJob> {
        const params = this.buildParams(filters);
        return this.http.post<ExportJob>(
            `${environment.api_url}/reports/excel/admin`,
            null,
            { params }
        );
    }

    getMyExportJobs(): Observable<ExportJobsResponse> {
        return this.http.get<ExportJobsResponse>(
            `${environment.api_url}/reports/excel/jobs`
        );
    }

    getAllExportJobs(): Observable<ExportJobsResponse> {
        return this.http.get<ExportJobsResponse>(
            `${environment.api_url}/reports/excel/jobs/all`
        );
    }

    downloadExportJob(jobUuid: string): Observable<Blob> {
        return this.http.get(
            `${environment.api_url}/reports/excel/jobs/${jobUuid}/download`,
            { responseType: 'blob' }
        );
    }

    private buildParams(filters: any): HttpParams {
        let params = new HttpParams();
        if (filters.category) params = params.set('category', filters.category);
        if (filters.subcategory) params = params.set('subcategory', filters.subcategory);
        if (filters.product) params = params.set('product', filters.product);
        if (filters.country) params = params.set('country', filters.country);
        if (filters.fromDate) params = params.set('fromDate', filters.fromDate);
        if (filters.toDate) params = params.set('toDate', filters.toDate);
        return params;
    }
}